import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Enums } from '@/lib/types/supabase';

type EtaUnitSelectProps = React.ComponentProps<typeof Select> & {
  triggerClassName?: string;
};

export const EtaUnitSelect = React.forwardRef<
  React.ElementRef<typeof Select>,
  EtaUnitSelectProps
>((props, ref) => {
  return (
    <Select {...props}>
      <SelectTrigger ref={ref} className={props.triggerClassName}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {ETA_UNITS.map((etaUnit) => (
          <SelectItem key={etaUnit} value={etaUnit} className="capitalize">
            {ETA_UNITS_LABELS[etaUnit]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

export const ETA_UNITS: Enums<'service_eta_unit_enum'>[] = ['day', 'week', 'month'];
export const ETA_UNITS_LABELS = {
  day: 'Jour(s)',
  week: 'Semaine(s)',
  month: 'Mois',
};
